/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=512,t=4096,c=8,e=.125;export{e as tileCoordinateScale,c as tilePixelRatio,o as tileSizeInPixels,t as tileSizeInTileUnits};
